/**
 * Global preloading boundary context to avoid prop drilling
 * and allows saving/restoring context during async operations
 */

// Global state to track current preloading boundary
let currentPreloadingBoundary: string = 'default';

/**
 * Get the current preloading boundary
 * @returns the current boundary name
 */
export function getCurrentPreloadingBoundary(): string {
	return currentPreloadingBoundary;
}

/**
 * Set the current preloading boundary
 * @param boundaryName the boundary name to set
 */
export function setCurrentPreloadingBoundary(boundaryName: string): void {
	currentPreloadingBoundary = boundaryName;
}
